// extracted by mini-css-extract-plugin
export var actionButton = "_97-1";
export var actionButtons = "_97-2";
export var actions = "_97-0";
export var aiUnread = "_97-10";
export var alignCenter = "_97-h";
export var backWrapper = "_97-3";
export var cellContainer = "_97-4";
export var checkboxContainer = "_97-5";
export var contentContainer = "_97-6";
export var contentHeader = "_97-8";
export var conversationsTableWrapper = "_97-s";
export var draftReplyBadgeContainer = "_97-m";
export var dropdownItem = "_97-b";
export var dropdownItemsContainer = "_97-a";
export var dropdownTitle = "_97-c";
export var errorIcon = "_97-7";
export var filter = "_97-d";
export var gray = "_97-i";
export var headerActionButtons = "_97-e";
export var headerCheckboxContainer = "_97-f";
export var icon = "_97-j";
export var menuContainer = "_97-k";
export var noMoreTicketsIcon = "_97-12";
export var noMoreTicketsSubText = "_97-13";
export var oneLine = "_97-l";
export var optionsButton = "_97-n";
export var plus = "_97-o";
export var portalButtonsWrapper = "_97-g";
export var red = "_97-p";
export var scrolledTop = "_97-9";
export var search = "_97-q";
export var selectedConversationsCount = "_97-r";
export var spinner = "_97-t";
export var strong = "_97-u";
export var summaryCell = "_97-v";
export var tableContainer = "_97-11";
export var tagContainer = "_97-w";
export var threeDots = "_97-x";
export var twoLines = "_97-y";
export var unread = "_97-z";